import React, { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { todayISO, formatDate } from "@/lib/format";
import { Loading, EmptyState } from "@/components/kit";
import { Users, Check } from "lucide-react";

export default function Booking() {
  const { user } = useAuth();
  const [date, setDate] = useState(todayISO());
  const [classes, setClasses] = useState(null);
  const [busy, setBusy] = useState("");

  const load = useCallback(async () => {
    setClasses(null);
    try { setClasses(await api.classesAvailable(user.member_id, date)); }
    catch { setClasses([]); }
  }, [user.member_id, date]);
  useEffect(() => { load(); }, [load]);

  const toggle = async (c) => {
    setBusy(c.id + c.time);
    try {
      if (c.joined) {
        await api.unenrollClass({ member_id: user.member_id, class_name: c.class_name, date: c.date, time: c.time });
        toast.success("Batal join kelas");
      } else {
        await api.enrollClass({ member_id: user.member_id, class_name: c.class_name, category: c.category, date: c.date, time: c.time });
        toast.success("Berhasil join kelas");
      }
      load();
    } catch (e) { toast.error(e.message); } finally { setBusy(""); }
  };

  return (
    <div className="space-y-5 fade-in">
      <div>
        <div className="hsc-label">Booking</div>
        <h1 className="font-display text-3xl text-white">Kelas</h1>
      </div>

      <input type="date" className="hsc-input" value={date} onChange={(e) => setDate(e.target.value)} data-testid="booking-date" />

      {classes === null ? <Loading /> : !classes.length ? (
        <EmptyState icon={Users} title="Tidak ada kelas" subtitle={`Tidak ada sesi pada ${formatDate(date)}.`} />
      ) : (
        <div className="space-y-3">
          {classes.map((c) => {
            const full = c.remaining <= 0 && !c.joined;
            return (
              <div key={c.id + c.time} className="rounded-2xl border border-[#1F1F22] bg-[#0A0A0C] p-4" data-testid="booking-class">
                <div className="flex items-start justify-between">
                  <div>
                    <div className="text-white">{c.class_name}</div>
                    <div className="mt-1 text-[12px] text-[#8E8E93]">{c.time_range || c.time} · {c.category}</div>
                    <div className="mt-1 text-[11px] text-[#6E6E73]">{c.enrolled}/{c.max} peserta</div>
                  </div>
                  <button
                    disabled={full || busy === c.id + c.time}
                    onClick={() => toggle(c)}
                    data-testid="booking-toggle"
                    className={`rounded-full px-4 py-2 text-[12px] font-semibold transition-colors ${
                      c.joined ? "border border-[#2C2C2E] text-[#D1D1D6]" : full ? "border border-[#1F1F22] text-[#5A5A5F]" : "bg-white text-black"
                    }`}
                  >
                    {c.joined ? "Batal" : full ? "Penuh" : <><Check className="mr-1 inline h-3.5 w-3.5" />Join</>}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
